import { SelectField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { BodyText, LabelText, TitleText } from '@calendly/ui/components/typography'

import { Buffers, EventLimits } from 'components/event_type_edit'

import { getSchedulingLimitsBufferOptions } from './buffer_options'
import { EVENT_TYPE_LIMIT_TYPES, EventTypeLimitRow } from './event_type_limit_row'
import { GlobalLimitsCard } from './global_limits_card'
import {
  bufferRowCss,
  dividerCss,
  eventTypeLimitsSubsectionCss,
  limitsCardCss,
  mainContentCss,
  pageHeaderCss,
  sectionCss,
  sectionHeaderCss,
  selectFieldCss,
  settingsCss,
} from './styles'

const BufferTimeFields = () => {
  const bufferOptions = getSchedulingLimitsBufferOptions()

  return (
    <div className={bufferRowCss} data-testid="buffer-time-fields">
      <div className={selectFieldCss}>
        <LabelText id="scheduling-limits-before-buffer-label" size="large">
          {I18n.t('publisher.event_type_editor_crud.scheduling_limits.before_meeting')}
        </LabelText>
        <SelectField
          aria-labelledby="scheduling-limits-before-buffer-label"
          name="beforeBuffer"
          options={bufferOptions}
        />
      </div>
      <div className={selectFieldCss}>
        <LabelText id="scheduling-limits-after-buffer-label" size="large">
          {I18n.t('publisher.event_type_editor_crud.scheduling_limits.after_meeting')}
        </LabelText>
        <SelectField
          aria-labelledby="scheduling-limits-after-buffer-label"
          name="afterBuffer"
          options={bufferOptions}
        />
      </div>
    </div>
  )
}

export const SchedulingLimitsPanel = ({
  isLocked = false,
}) => (
  <div className={mainContentCss} data-testid="scheduling-limits-panel">
    <header className={pageHeaderCss}>
      <TitleText level={2} size="large">
        {I18n.t('publisher.event_type_editor_crud.scheduling_limits.page_title')}
      </TitleText>
      <BodyText color="muted" size="large">
        {I18n.t('publisher.event_type_editor_crud.scheduling_limits.page_description')}
      </BodyText>
    </header>

    <div className={settingsCss}>
      <section className={sectionCss} data-testid="buffer-time-section">
        <div className={sectionHeaderCss}>
          <TitleText level={3} size="medium">
            {I18n.t('publisher.event_type_editor_crud.scheduling_limits.buffer_title')}
          </TitleText>
          <BodyText color="muted" size="medium">
            {I18n.t('publisher.event_type_editor_crud.scheduling_limits.buffer_description')}
          </BodyText>
        </div>
        {!isLocked ? <BufferTimeFields /> : <Buffers isLocked />}
      </section>

      <div className={dividerCss} role="presentation" />

      <section className={sectionCss} data-testid="meeting-limits-section">
        <div className={sectionHeaderCss}>
          <TitleText level={3} size="medium">
            {I18n.t('publisher.event_type_editor_crud.scheduling_limits.meeting_limits')}
          </TitleText>
          <BodyText color="muted" size="medium">
            {I18n.t('publisher.event_type_editor_crud.scheduling_limits.meeting_limits_description')}
          </BodyText>
        </div>

        <div className={eventTypeLimitsSubsectionCss}>
          <LabelText size="large">
            {I18n.t('publisher.event_type_editor_crud.scheduling_limits.event_type_limits')}
          </LabelText>
          <BodyText color="muted" size="medium">
            {I18n.t('publisher.event_type_editor_crud.scheduling_limits.event_type_limits_description')}
          </BodyText>
        </div>

        {isLocked ? (
          <EventLimits isLocked />
        ) : (
          <div className={limitsCardCss} data-testid="event-type-limits-card">
            {EVENT_TYPE_LIMIT_TYPES.map((limitType) => (
              <EventTypeLimitRow
                key={limitType}
                isLocked={isLocked}
                limitType={limitType}
              />
            ))}
          </div>
        )}
      </section>

      <GlobalLimitsCard />
    </div>
  </div>
)
